/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceRoleCreationDetails
 */
export interface ServiceRoleCreationDetails {
    /**
     * 
     * @type {boolean}
     * @memberof ServiceRoleCreationDetails
     */
    canBeAdded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceRoleCreationDetails
     */
    message?: string;
}

/**
 * Check if a given object implements the ServiceRoleCreationDetails interface.
 */
export function instanceOfServiceRoleCreationDetails(value: object): value is ServiceRoleCreationDetails {
    return true;
}

export function ServiceRoleCreationDetailsFromJSON(json: any): ServiceRoleCreationDetails {
    return ServiceRoleCreationDetailsFromJSONTyped(json, false);
}

export function ServiceRoleCreationDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceRoleCreationDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'canBeAdded': json['canBeAdded'] == null ? undefined : json['canBeAdded'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ServiceRoleCreationDetailsToJSON(json: any): ServiceRoleCreationDetails {
    return ServiceRoleCreationDetailsToJSONTyped(json, false);
}

export function ServiceRoleCreationDetailsToJSONTyped(value?: ServiceRoleCreationDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canBeAdded': value['canBeAdded'],
        'message': value['message'],
    };
}

